exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MwUwVDc3EwhKiBlTqrCes {\n  display: flex;\n  height: 100vh;\n  font-size: 45px;\n  color: #075189;\n  text-align: center;\n  align-content: center;\n  align-items: center;\n  justify-content: center; }\n  .MwUwVDc3EwhKiBlTqrCes img {\n    max-width: 10%;\n    height: auto; }\n", ""]);

// Exports
exports.locals = {
	"maintenanceContainer": "MwUwVDc3EwhKiBlTqrCes"
};